import {useEffect,useState} from 'preact/hooks';
import {useClient} from '@/ui/context';
import {Button} from '@/ui/components';
import {masteryView,requestMastery,subscribeMastery} from '@/spell-mastery';
export function RebirthPanel(){
 const client=useClient();const [view,setView]=useState(()=>masteryView(client));
 useEffect(()=>{const off=subscribeMastery(client,()=>setView({...masteryView(client)}));requestMastery(client);return off;},[client]);
 const r=view.rebirth;
 return <section class='space-y-3 p-3 text-sm' data-rebirth-panel>
  <h3 class='font-semibold text-primary'>Rebirth</h3>
  <p>At level 250 or higher, begin again at level 0. Each rebirth grants 20 additional permanent stat points.</p>
  <p>Your allocated combat stats reset. Your permanent point pool is returned for you to allocate again. Learned spells, spell mastery, life skills, achievements and items are kept.</p>
  <p>Rebirths: {r?.count??'…'} · Permanent stat points: {r?.permanent_points??'…'}</p>
  <p>After your next rebirth: {(r?.permanent_points??0)+20} available permanent stat points.</p>
  {view.error&&<p role='alert' class='text-error'>{view.error}</p>}
  <Button variant={['sm','primary']} disabled={!r||view.pending||!r.near_master||r.level<r.required_level}
   onClick={()=>client.alertController.showConfirm('Confirm Rebirth',`Reset your level and combat stats? You will keep ${(r?.permanent_points??0)+20} permanent stat points, your learned spells and life skills.`,ok=>{if(ok)requestMastery(client,'rebirth');})}>Rebirth · Level 250+</Button>
 </section>;
}
